import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  headingTitle: {
    id: "course-authoring.studio-home.heading.title",
    defaultMessage: "{studioShortName} home",
  },
  addNewCourseBtnText: {
    id: "course-authoring.studio-home.add-new-course.btn.text",
    defaultMessage: "New course",
  },
  addNewLibraryBtnText: {
    id: "course-authoring.studio-home.add-new-library.btn.text",
    defaultMessage: "New library",
  },
  homePageLoadFailedMessage: {
    id: "course-authoring.studio-home.page-load.failed.message",
    defaultMessage: "Failed to load Studio home. Please try again later.",
  },
  emailStaffBtnText: {
    id: "course-authoring.studio-home.email-staff.btn.text",
    defaultMessage: "Email staff to create course",
  },
  defaultSection_1_Title: {
    id: "course-authoring.studio-home.default-section-1.title",
    defaultMessage: "Are you staff on an existing {studioShortName} course?",
  },
  defaultSection_1_Description: {
    id: "course-authoring.studio-home.default-section-1.description",
    defaultMessage:
      "The course creator must give you access to the course. Contact the course creator or administrator for the course you are helping to author.",
  },
  defaultSection_2_Title: {
    id: "course-authoring.studio-home.default-section-2.title",
    defaultMessage: "Create your first course",
  },
  defaultSection_2_Description: {
    id: "course-authoring.studio-home.default-section-2.description",
    defaultMessage: "Your new course is just a click away!",
  },
  btnAddNewCourseText: {
    id: "course-authoring.studio-home.btn.add-new-course.text",
    defaultMessage: "Create your first course",
  },
  btnReRunText: {
    id: "course-authoring.studio-home.btn.re-run.text",
    defaultMessage: "Re-run course",
  },
  viewLiveBtnText: {
    id: "course-authoring.studio-home.btn.view-live.text",
    defaultMessage: "View live",
  },
  organizationTitle: {
    id: "course-authoring.studio-home.organization.title",
    defaultMessage: "Organization and library settings",
  },
  organizationLabel: {
    id: "course-authoring.studio-home.organization.label",
    defaultMessage: "Show all courses in organization:",
  },
  organizationSubmitBtnText: {
    id: "course-authoring.studio-home.organization.btn.submit.text",
    defaultMessage: "Submit",
  },
  organizationInputPlaceholder: {
    id: "course-authoring.studio-home.organization.input.placeholder",
    defaultMessage: "For example, MITx",
  },
  organizationInputNoOptions: {
    id: "course-authoring.studio-home.organization.input.no-options",
    defaultMessage: "No options",
  },
  deleteCourseButtonText: {
    id: "course-authoring.studio-home.organization.btn.delete.course",
    defaultMessage: "Delete Course",
  },
});

export default messages;
